import z from 'zod';

export type Author = z.infer<typeof Author>;

export const Author = z.object({
  id: z.string(),
  name: z.string(),
  username: z.string(),
});
